export default {
  subtitle: 'As chaves autenticam pedidos à API de parceiros. Envie-as no cabeçalho x-api-key.',
  never_used: 'Nunca utilizada',
  revoke_confirm: 'Revogar esta chave? Os pedidos que a utilizam deixarão de funcionar de imediato.',
  columns: {
    name: 'Nome',
    key: 'Chave',
    status: 'Estado',
    last_used_at: 'Última utilização',
    created_at: 'Criada em',
  },
  statuses: {
    active: 'Ativa',
    revoked: 'Revogada',
  },
  buttons: {
    create: 'Criar chave',
    revoke: 'Revogar',
  },
  toasts: {
    load_error: 'Não foi possível carregar as chaves de API.',
    error: 'Ocorreu um erro. Tente novamente.',
    revoked: 'Chave de API revogada.',
  },
};
